import React, { ReactNode } from 'react'
import {
  Text,
  StyleProp,
  ViewStyle,
  StyleSheet,
  NativeSyntheticEvent,
  TextInputSubmitEditingEventData,
} from 'react-native'

import LensIcon from 'app/icons/Lens'
import {
  BORDER_STYLES,
  COLORS,
  Input,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'

interface Props {
  inputContainerStyle?: StyleProp<ViewStyle>
  searchIconContainer?: StyleProp<ViewStyle>
  leftIcon?: ReactNode
  placeholder: string
  value?: string
  onChange: (text: string) => void
  inputStyle?: StyleProp<ViewStyle>
  onSubmitEditing?: (
    event: NativeSyntheticEvent<TextInputSubmitEditingEventData>,
  ) => void
  error?: boolean
  errorText?: string
}
function SearchInput({
  inputContainerStyle,
  searchIconContainer,
  leftIcon,
  placeholder,
  onChange,
  value,
  inputStyle,
  onSubmitEditing,
  error,
  errorText,
}: Props) {
  const leftLabelIcon = (
    <LensIcon
      svgProps={{
        width: 16,
        height: 16,
        fill: 'none',
        style: { marginLeft: 16, marginRight: 8 },
      }}
    />
  )

  return (
    <>
      <Input
        leftLabelIcon={leftIcon || leftLabelIcon}
        containerStyle={[
          styles.inputContainer,
          inputContainerStyle,
          error && BORDER_STYLES.borderError100,
        ]}
        value={value}
        onChangeText={onChange}
        style={[styles.h3, inputStyle]}
        label={placeholder}
        onSubmitEditing={onSubmitEditing}
      />
      {error && errorText ? (
        <Text
          style={[
            TYPOGRAPHY.CAPTION1,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textError100,
          ]}
        >
          {errorText}
        </Text>
      ) : null}
    </>
  )
}

const styles = StyleSheet.create({
  h3: {
    height: 48,
  },
  inputContainer: {
    height: 48,
    width: '100%',
    flex: 1,
    marginVertical: 0,
    paddingHorizontal: 0,
    backgroundColor: COLORS.white,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: COLORS.neutral20,
  },
  iconContainer: {
    height: 32,
    width: 48,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    borderLeftColor: COLORS.neutral20,
    borderLeftWidth: 1,
  },
})

export default SearchInput
